<script setup lang="ts">

import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref } from "vue";

const props = defineProps<{
	auth?: { name: string };
	title: string;
}>();

const navbarActive = ref(false);

const emit = defineEmits<{
	(event: "clearAuth"): void;
}>();

function clearAuth() {
	emit("clearAuth");
}

</script>

<template>
	<nav class="navbar is-dark">
		<div class="container">
			<div class="navbar-brand">
				<router-link class="navbar-item" to="/">
					<img src="@/assets/img/logo.png" alt="Volt Logo" />
				</router-link>
				<h1 class="navbar-item">
					{{ title }}
				</h1>
				<a role="button" class="navbar-burger has-text-white"
				   :class="navbarActive ? 'is-active' : ''" aria-label="menu"
				   aria-expanded="false"
				   @click="navbarActive = !navbarActive"
				   data-target="navbarBasicExample">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>
			<div class="navbar-menu" :class="navbarActive ? 'is-active' : ''">
				<div class="navbar-end">
					<div class="navbar-item" v-if="auth">
						Angemeldet als: {{ auth.name }}
					</div>
					<div class="navbar-item" v-if="auth">
						<button @click="clearAuth" class="button is-danger">
							<font-awesome-icon :icon="faSignOutAlt" />
						</button>
					</div>
				</div>
			</div>
		</div>
	</nav>
</template>

<style scoped>

</style>
